import { Cushion, FlexContainer, Grid, Rectangle, Typography } from '@pitchero/react-ui';
import PropTypes from 'prop-types';
import React from 'react';
import { Trans } from '../../lib/i18n';
import useBreakpoint from '../../lib/use-breakpoint';
import MatchEventIcon from './match-event-icon';
import getMatchEventTime from './match-event-time';
import { isHomeTeamEvent, eventPlayerName } from './helpers';
import { keyEventTypes } from './constants';

const KeyMoments = ({ events }) => {
  const filteredEvents = events.flatMap((period) =>
    period.events.filter((event) => keyEventTypes.includes(event.eventType.toLowerCase())),
  );

  const isMobile = useBreakpoint();

  return (
    <Rectangle
      fill="white"
      style={{ border: '1px solid #d9d9d9', overflow: 'hidden' }}
      responsive={[{ minWidth: 'fullHeader', props: { radius: 'rounded' } }]}
    >
      <Rectangle fill="#fafafa" borderBottom="1px solid #d9d9d9">
        <Cushion all="small">
          <Typography size={16} weight="bold" color="black" align="center" component="h3">
            <Trans i18nKey="teams:key_moments">Key Moments</Trans>
          </Typography>
        </Cushion>
      </Rectangle>
      <FlexContainer flexDirection="column" alignItems="center" style={{ padding: '20px 5px' }}>
        {filteredEvents.map((event, index) => (
          <FlexContainer flexDirection="column" alignItems="center">
            <Grid
              key={event.id}
              columns="1fr 30px 1fr"
              columnGap={isMobile ? '10px' : '30px'}
              areas="'home time away'"
              alignItems="center"
              component="div"
            >
              <Typography align="center" color="#757575" size={16} style={{ gridArea: 'time' }}>
                {getMatchEventTime(event.time)}
              </Typography>
              <FlexContainer
                flexDirection={isHomeTeamEvent(event) ? 'row' : 'row-reverse'}
                justifyContent={isHomeTeamEvent(event) ? 'end' : 'start'}
                alignItems="center"
                flexWrap={isHomeTeamEvent(event) ? 'wrap' : 'wrap-reverse'}
                style={{ gap: '5px', gridArea: isHomeTeamEvent(event) ? 'home' : 'away' }}
              >
                <MatchEventIcon {...event.icon} size={16} />
                <Typography weight="bold" size={isMobile ? '14px' : '16px'}>
                  {eventPlayerName(event)}
                </Typography>
              </FlexContainer>
            </Grid>
            {index !== filteredEvents.length - 1 && (
              // Show vertical line under all but last event
              <Rectangle fill="#000" style={{ width: '2px', height: '20px' }} />
            )}
          </FlexContainer>
        ))}
      </FlexContainer>
    </Rectangle>
  );
};

KeyMoments.propTypes = {
  homeOrAway: PropTypes.oneOf(['h', 'a']).isRequired,
  events: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default KeyMoments;
